<!--

	Page that creates list of FAQ categories

-->
<template>
	<div class="mia-CategoryAnsweredQuestions">
		<h3>
			{{ item.Category }}
		</h3>
		<list-store-registration :store="listStore" :initial-data="initialData" />
		<conversion-store-registration :store="conversionStore" :initial-conversions="conversions" />
		<vue-list 
			:items="listStore"
			:conversions="conversionStore"
			template="answered-question"
			:item-props="{
				expandedQuestionWhenSearchQueryIsEmpty,
				setExpandedQuestionWhenSearchQueryIsEmpty,
				searchQuery,
				targetQuestion
			}"
		/>
	</div>
</template>
<script lang="ts">
import { Component, Prop, toNative } from "vue-facing-decorator";
import { MiaPlaza } from "@/Reinforced.Typings";
import { Item } from "@/Control/Vue/Lists/VueList/Items/Item";
import { DefaultFAQCategory } from "@/Control/Vue/Defaults";
import VueList from "@/Control/Vue/Lists/VueList/VueList.vue";
import ConversionStoreRegistration from "@/Control/Vue/Stores/VueList/ConversionStoreRegistration";
import ListStoreRegistration from "@/Control/Vue/Stores/VueList/ListStoreRegistration";

@Component({
	components: {
		VueList,
		ConversionStoreRegistration,
		ListStoreRegistration
	}
})
export class CategoryAnsweredQuestions extends Item<MiaPlaza.ConfigModel.FAQ.IFAQCategory> {
	@Prop({ required: true, type: String }) searchQuery!: string;
	@Prop({ required: false, default: null }) expandedQuestionWhenSearchQueryIsEmpty!: string | null;
	@Prop({ required: true, type: Function }) setExpandedQuestionWhenSearchQueryIsEmpty!: (question: string | null) => void;
	@Prop({ required: true, type: Array }) filteredCategoryAnsweredQuestions!: MiaPlaza.ConfigModel.FAQ.IFAQCategory[];
	@Prop({ required: false, type: Object, default: null }) targetQuestion!: MiaPlaza.ConfigModel.FAQ.IAnsweredQuestion | null;

	protected defaults = DefaultFAQCategory;

	get listStore() {
		return `faq-category-${this.item.Category}-list`;
	}

	get conversionStore() {
		return `faq-category-${this.item.Category}-conversion`;
	}

	get filteredAnsweredQuestions() {
		return this.filteredCategoryAnsweredQuestions.find(category => this.item.Category === category.Category)?.AnsweredQuestions ?? [ ];
	}

	get conversions() {
		const answeredQuestions: {[question: string]: MiaPlaza.ConfigModel.FAQ.IAnsweredQuestion } = { }
		for(const answeredQuestion of this.filteredAnsweredQuestions) {
			answeredQuestions[answeredQuestion.Question] = answeredQuestion;
		}
		return answeredQuestions;
	}

	get initialData() {
		return {
			Items: this.filteredAnsweredQuestions.map(answeredQuestion => answeredQuestion.Question),
			TotalCountEstimate: this.filteredAnsweredQuestions.length,
			UnfilteredLimit: 0,
			UnfilteredOffset: 0
		};
	}
}

export default toNative(CategoryAnsweredQuestions);
</script>
<style lang="scss">
.mia-CategoryAnsweredQuestions {
	h3 {
		color: theme.$mia-color-panel-font;
		background-color: inherit;
		margin-top: theme.$mia-margin-size-xl;
		margin-bottom: theme.$mia-margin-size-xl;
	}

	.mia-listItem:not(:last-child) {
		padding-bottom: theme.$mia-padding-panel;
	}
}
</style>

